@import "../../../variables";

.root {
  display: flex;
  gap: 8px;

  .form {
    width: 300px;

    .formTitle {
      font-size: 13px;
      font-weight: 500;
      color: #424242;
      margin-bottom: 8px;
    }
  }
}

@media (max-width: 600px) {
  .root {
    flex-direction: column;
    align-items: stretch;
  }

  .root .form {
    width: auto;
    max-width: 100%;
  }
}
